import { ACTION_TYPE } from '../constants/actionType'

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.showTransferDialog: {
      const { data, onTransfer, onClose } = action.payload
      return { isShow: true, data, onTransfer, onClose }
    }
    case ACTION_TYPE.hideTransferDialog: {
      return {
        isShow: false,
        data: {},
        onTransfer: () => {},
        onClose: () => {},
      }
    }
    default: {
      return state
    }
  }
}

const initialState = {
  isShow: false,
  data: {},
  onTransfer: () => {},
  onClose: () => {},
}

const initialize = (initialState = {}) => initialState

const reducerArgs = [reducer, initialState, initialize]

export default reducerArgs
